import $ from 'jquery';

export default function videoPlay() {
  $('.play-video')
    .on('click', function (e) {
      if ($(this).hasClass('file')) {
        $('#video').trigger('play');
        $(this).hide();
      } else {
        $('.video iframe')[0].src += '&autoplay=1';
        e.preventDefault();
        $('.video .frame').show();
        $('.play-video').hide();
        $('.video-image').hide();
      }
    });
}
